document.addEventListener('DOMContentLoaded', function() {
  const slider = document.querySelector('.ecomdv-testimonial-slider');
  const slides = document.querySelectorAll('.ecomdv-testimonial-slide');
  const dotsContainer = document.querySelector('.ecomdv-slider-dots');
  let currentIndex = 0;
  let slideInterval;
  
  // Create dots
  slides.forEach((_, index) => {
    const dot = document.createElement('span');
    dot.addEventListener('click', () => goToSlide(index));
    dotsContainer.appendChild(dot);
  });
  
  const dots = document.querySelectorAll('.ecomdv-slider-dots span');
  updateActiveStates();
  
  // Enhanced auto slide function
  function startSlider() {
    slideInterval = setInterval(() => {
      currentIndex = (currentIndex + 1) % slides.length;
      animateToCurrentSlide();
    }, 5000); // Change slide every 5 seconds
  }
  
  function animateToCurrentSlide() {
    slider.style.transform = `translateX(-${currentIndex * 100}%)`;
    updateActiveStates();
  }
  
  function goToSlide(index) {
    currentIndex = index;
    animateToCurrentSlide();
    resetInterval();
  }
  
  function updateActiveStates() {
    // Update dots
    dots.forEach((dot, index) => {
      dot.classList.toggle('ecomdv-active', index === currentIndex);
    });
    
    // Update slides
    slides.forEach((slide, index) => {
      slide.classList.toggle('ecomdv-active', index === currentIndex);
    });
  }
  
  function resetInterval() {
    clearInterval(slideInterval);
    startSlider();
  }
  
  // Start the slider
  startSlider();
  
  // Pause on hover
  const container = document.querySelector('.ecomdv-testimonial-slider-container');
  container.addEventListener('mouseenter', () => clearInterval(slideInterval));
  container.addEventListener('mouseleave', startSlider);
  
  // Touch support for mobile
  let touchStartX = 0;
  let touchEndX = 0;
  
  slider.addEventListener('touchstart', (e) => {
    touchStartX = e.changedTouches[0].screenX;
    clearInterval(slideInterval);
  }, {passive: true});
  
  slider.addEventListener('touchend', (e) => {
    touchEndX = e.changedTouches[0].screenX;
    handleSwipe();
    startSlider();
  }, {passive: true});
  
  function handleSwipe() {
    const threshold = 50;
    if (touchEndX < touchStartX - threshold) {
      // Swipe left - next slide
      currentIndex = (currentIndex + 1) % slides.length;
    } else if (touchEndX > touchStartX + threshold) {
      // Swipe right - previous slide
      currentIndex = (currentIndex - 1 + slides.length) % slides.length;
    }
    animateToCurrentSlide();
  }
});